import classNames from "classnames"
import { BackgroundDesignator } from "components/DesignSystem"
import { PaperBox } from "components/PaperBox/PaperBox"
import { PropsWithChildren } from "react"

/**
 * Preset spacing options for `Paper`.
 */
export type PaperPadding = "sm" | "md" | "lg"

const paddingClasses: Record<PaperPadding, string> = {
  sm: "p-4",
  md: "p-4 lg:p-8",
  lg: "p-4 lg:p-10",
}

type Props = PropsWithChildren<{
  id?: string

  /**
   * @deprecated
   */
  className?: string

  centered?: boolean
  padding?: PaperPadding
  background?: BackgroundDesignator
}>

/**
 * Wraps child components. It adds padding and a white background (et cetera)
 * similar to being on paper. Composes `PaperBox` for the border/background
 * chrome and layers on flex, padding, and optional centering.
 */
export const Paper = ({ children, className, centered = true, padding = "lg", background, id }: Props) => (
  <PaperBox
    id={id}
    background={background}
    className={classNames(
      "flex flex-col gap-2",
      paddingClasses[padding],
      centered && "items-center justify-center",
      className
    )}
  >
    {children}
  </PaperBox>
)
